import { orderXClient } from '@/service/client'
import {
  CreatePresetRequest,
  DeletePresetRequest,
  ExecutePresetRequest,
  ListPresetsResponse,
  Preset,
  UpdatePresetRequest,
} from '@/types/generated/preset'
import { ServerMessage } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function listPresets(): Promise<ListPresetsResponse> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      listPresets: {},
    })
    return data.listPresetsResponse as ListPresetsResponse
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function createPreset(
  payload: Omit<CreatePresetRequest, 'payload'> & { payload: CreatePresetRequest['payload'] }
): Promise<Preset> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      createPreset: payload,
    })
    return data.createPresetResponse?.preset as Preset
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function updatePreset(payload: UpdatePresetRequest): Promise<Preset> {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      updatePreset: payload,
    })
    return data.updatePresetResponse?.preset as Preset
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function deletePreset(presetId: string): Promise<void> {
  try {
    await orderXClient.post<ServerMessage>('/api', {
      deletePreset: { presetId } satisfies DeletePresetRequest,
    })
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function executePreset(payload: ExecutePresetRequest): Promise<void> {
  try {
    await orderXClient.post<ServerMessage>('/api', {
      executePreset: payload,
    })
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
